import styled from 'styled-components';

export const Container = styled.div`
  h3 {
    font-weight: 600;
  }
`;
